//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Box,
  Stack,
  Button,
} from "@mui/material";
import { QRCode } from "react-qrcode-logo";
import { makeStyles } from "tss-react/mui";
import axios, { AxiosRequestConfig } from "axios";
import { useGetToken } from "../../hooks/useGetToken";
import ImageWithTick from "../../components/ImageWithTick";
import Context from "../../context";
import { Call, QrCode, Tune } from "@mui/icons-material";
import ImageUpload from "../../components/ImageUpload";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useGlobalStateContext } from "../../context/globalState";
import {
  STUBBED_IMAGE_DOWNLOAD_DATA,
  STUBBED_INSTALLER_DATA,
  STUBBED_QR_CODE_DATA,
} from "../../stubbedData/stubbedPassportResponse";
import { useTranslation } from "react-i18next";
import PassportPageHeader from "../../components/PassportPageHeader";
import PassportPageBottom from "../../components/PassportPageBottom";
import { isSmpEmployeeId } from "../../utils/smpEmployeeId";
import Item from "../../styledComponents/styledItem";
import TextLabel from "../../components/TextLabel";
import { logUserAction } from "../../utils/apiUtils";
import { CONSTANTS } from "../../CONSTANTS";
import Loading from "../../components/Loading";
import AlertBox from "../../components/AlertBox";

interface InstallerData {
  first_name: string;
  last_name: string;
  company_id: string;
  role_id: string;
  user_id: string;
  profileImgName: string;
  qualificationTypes: string[];
  passportTypes: string[];
  status: string;
  statusReason: string;
  statusStartDate: string;
}

const useStyles = makeStyles()(() => ({
  content: {
    padding: "20px",
    marginTop: "20px",
    width: "95%",
  },
  headerInfo: {
    display: "flex",
    justifyContent: "center",
    textAlign: "left",
  },
  container: {
    height: "100%",
    margin: "0",
  },
  wrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    marginLeft: "20px !important",
  },
  statusContainer: {
    display: "inline-flex",
    position: "relative",
    left: "20%",
    top: "-5%",
    zIndex: 100,
  },
  statusText: {
    display: "inline",
    marginTop: "-10px",
    marginLeft: "-5px",
  },
  avatarMargin: {
    marginLeft: "-40px !important",
    marginTop: "10px !important",
  },
}));

const ProfilePage: React.FC = ({ onSignOut }) => {
  const {
    authState: { user },
  } = useContext(Context);
  const {
    qualificationsList,
    trainingTypes,
    loading,
    beginLoading,
    endLoading,
  } = useGlobalStateContext();
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState<InstallerData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [photo, setPhoto] = useState<string | null>(null);
  const [qrCode, setQrCode] = useState<string>("");
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [blockAlertVisible, setBlockAlertVisible] = useState<boolean>(false);
  const [userBlocked, setUserBlocked] = useState<{
    status: boolean;
    message: string;
  }>({
    status: false,
    message: "",
  });
  const { classes } = useStyles();
  const [getToken] = useGetToken();
  const [values, setValues] = useState<{
    photo: string | null;
    fileType: string;
  }>({ photo: null, fileType: "" });
  const navigate = useNavigate();

  const handleSignOut = () => {
    // Add your sign out logic here
    navigate("/SignOut");
  };

  const fetchData = async () => {
    const loadingToken = beginLoading("profile-page-installer-data");
    if (window.location.href.includes("/test")) {
      setData(STUBBED_INSTALLER_DATA[0]);
      endLoading(loadingToken);
      return;
    }

    const token = await getToken();
    const getQueryParams = () => {
      const params = new URLSearchParams();
      if (user?.username) {
        params.set("emailId", user.username);
        if (!user.username?.includes("@kone.com")) {
          params.set("sub", "true");
        }
      } else {
        params.set("userName", user?.name ?? "");
        params.set("sub", "true");
      }
      return `?${params.toString()}`;
    };
    const uri = `${process.env.REACT_APP_API_ENDPOINT}/v1/installers/view${getQueryParams()}`;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    try {
      const response = await axios.get(uri, config);
      const installerData = response.data.installer[0];
      setData(installerData);
      if (installerData.status.toLowerCase() === "active") {
        setUserBlocked({ status: false, message: "" });
        setBlockAlertVisible(false);
      } else {
        setUserBlocked({
          status: true,
          message: installerData.statusReason || t("alertMessages.userBlocked"),
        });
        setBlockAlertVisible(true);
      }
    } catch (err) {
      console.error(err);
      setError(t("error_messages.fetchDataFailed"));
    } finally {
      endLoading(loadingToken);
    }
  };

  const handleImagedata = async () => {
    const loadingToken = beginLoading("profile-page-image-data");
    if (window.location.href.includes("/test")) {
      setPhoto(STUBBED_IMAGE_DOWNLOAD_DATA.imageUrl[0].signedUrl);
      endLoading(loadingToken);
      return;
    }
    const token = await getToken();
    const uri = `${process.env.REACT_APP_API_ENDPOINT}/v1/attachments/download`;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const payload = {
      attachments: [
        {
          filename: data?.profileImgName,
          location: data?.profileImgName,
        },
      ],
    };

    try {
      const response = await axios.post(uri, payload, config);
      setPhoto(response.data.imageUrl[0].signedUrl);
    } catch (err) {
      console.error(err);
      setError(t("error_messages.imageLoadError").toString());
    } finally {
      endLoading(loadingToken);
    }
  };

  const getQrCodeImage = async () => {
    const loadingToken = beginLoading("profile-page-qr-code");
    if (window.location.href.includes("/test")) {
      setQrCode(STUBBED_QR_CODE_DATA.data);
      endLoading(loadingToken);
      return;
    }
    const getQueryParams = () => {
      const params = new URLSearchParams();
      if (user?.username) {
        params.set("emailId", user.username);
        if (!user.username.trim().toLowerCase().endsWith("@kone.com")) {
          params.set("sub", "true");
        }
      } else {
        params.set("userName", user?.name ?? "");
        params.set("sub", "true");
      }
      return `?${params.toString()}`;
    }
    const token = await getToken();
    const uri = `${process.env.REACT_APP_API_ENDPOINT}/v1/qrcode${getQueryParams()}`;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    try {
      const response = await axios.get(uri, config);
      setQrCode(response.data.data);
      response.data.data &&
        logUserAction(token, user.username, CONSTANTS.USER_ACTION.QR_CODE);
    } catch (err) {
      console.error(err);
      setError(t("error_messages.dataLoadError").toString());
    } finally {
      endLoading(loadingToken);
    }
  };
  useEffect(() => {
    if (error) {
      setError(null);
    }
    fetchData();
    getQrCodeImage();
  }, []);

  useEffect(() => {
    if (error) {
      setError(null);
    }
    if (data?.profileImgName) {
      handleImagedata();
    }
  }, [data]);

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = document.querySelector(".header")?.clientHeight || 0;
      const breadcrumbsHeight =
        document.querySelector(".breadcrumbs")?.clientHeight || 0;
      const alertBoxHeight =
        document.querySelector(".alert-box")?.clientHeight || 0;
      const totalHeight =
        headerHeight + breadcrumbsHeight + alertBoxHeight + 50; // Add some padding
      setTableHeight(window.innerHeight - totalHeight);
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);

    return () => {
      window.removeEventListener("resize", calculateHeight);
    };
  }, []);

  const handleImageUploadError = (state: { type: string; message: string }) => {
    setError(state.type === "error" ? state.message : null);
  };

  const handleImageChange = async (base64Image: string, fileType: string) => {
    setValues({
      ...values,
      photo: base64Image, // Set the Base64 image string to the form state
      fileType: fileType,
    });

    const token = await getToken();
    let updatedData = {};

    updatedData = {
      photo: base64Image,
      fileType: fileType,
    };
    const userId = data.userId;
    const formData = { updatedData, userId };
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/updateProfile`,
        formData,
        config,
      );
      logUserAction(token, user.username, CONSTANTS.USER_ACTION.PROFILE);
    } catch (err) {
      console.error(err);
      setError(t("error_messages.updateImageFailed"));
    }
  };

  if (!data) {
    return (
      <div style={{ maxHeight: `${tableHeight}px`, overflow: "auto" }}>
        <PassportPageHeader onSignOut={onSignOut} />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          height="100%"
        >
          <div
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              position: "sticky",
              left: "0",
              zIndex: 200,
            }}
          >
            {!loading ? (
              <AlertBox
                type={"error"}
                message={t(
                  "error_messages.dataLoadError",
                  "Data could not be loaded. Please try again.",
                ).toString()}
                onCloseCb={onCloseAlertBox}
              />
            ) : (
              <AlertBox
                type={"info"}
                message={t(
                  "alertMessages.dataLoading",
                  "Data is loading, please wait...",
                ).toString()}
                onCloseCb={onCloseAlertBox}
              />
            )}
          </div>
          <PassportPageBottom />
        </Box>
      </div>
    );
  }

  const handleNavigation = (path?: string) => {
    navigate(path || "/");
  };

  function onCloseAlertBox() {
    setError(null);
  }

  function onCloseUserBlockedAlertBox() {
    setBlockAlertVisible(false);
  }

  function openUserBlockedAlertBox() {
    setBlockAlertVisible(true);
  }

  /** One country-configurable custom field value, as it should read here. */
  const formatCustomFieldValue = (fieldType: string, raw: unknown): string => {
    if (raw === null || raw === undefined || raw === "")
      return t("passportPage.labels.notApplicable");
    if (fieldType === "checkbox")
      return raw === true || raw === 1 || raw === "1" || raw === "true"
        ? t("common.yes")
        : t("common.no");
    if (fieldType === "date") {
      // A DATE column reaches the client either as an ISO timestamp or already
      // as YYYY-MM-DD. Taking the date part avoids the timezone shift that
      // re-parsing it would introduce.
      const text = String(raw);
      const datePart = text.match(/^\d{4}-\d{2}-\d{2}/);
      return datePart ? datePart[0] : text;
    }
    return String(raw);
  };

  /**
   * The country's custom fields, appended after the built-in passport details.
   *
   * `fieldSchema` arrives already narrowed to this user's audience - the view
   * endpoint resolves it from the user's own vendor_id and business types - so
   * nothing is filtered again here. Rendering exactly what it returns is what
   * keeps this page and the scanned QR passport showing the same fields.
   *
   * Fields with no stored value are kept and shown as N/A: on a passport,
   * "no permit recorded" is information a verifier needs, not noise.
   */
  const customFieldDetails = (data.fieldSchema || [])
    .filter((item) => item.source === "custom" && item.isVisible)
    .map((item) => ({
      label: item.displayName || item.key,
      value: formatCustomFieldValue(
        item.fieldType,
        (data.customFields || {})[item.storageColumn || item.key],
      ),
    }));

  // Array of profile fields to display in the profile details section
  const profileDetails = [
    {
      label: t("passportPage.labels.name"),
      value: `${data.firstName} ${data.lastName}`,
    },
    {
      label: t("passportPage.labels.company"),
      value: data.companyLastName
        ? `${data.companyFirstName} ${data.companyLastName}`
        : data.companyFirstName,
    },
    {
      label: t("passportPage.labels.jobTitle"),
      value: data.roleName === "Others" ? data.customRoleName : data.roleName,
    },
    {
      label: isSmpEmployeeId(data.koneEmployeeId)
        ? t("passportPage.labels.smpEmployeeId")
        : t("passportPage.labels.passportId"),
      value: data.koneEmployeeId,
    },
    {
      label: t("passportPage.labels.passportType"),
      value:
        data.passportTypes && data.passportTypes.length > 0
          ? data.passportTypes
          : [t("passportPage.labels.notApplicable")],
      isMultiLine: true,
    },
    { label: t("passportPage.labels.assessorName"), value: data.assessorName },
    { label: t("passportPage.labels.emailId"), value: data.emailId },
    {
      label: t("passportPage.labels.qualifiedToWork"),
      value: data.qualifiedCountryNames,
    },
    {
      label: t("passportPage.labels.qualificationTypes"),
      value:
        data.qualificationTypes && data.qualificationTypes.length > 0
          ? data.qualificationTypes
          : [t("passportPage.labels.notApplicable")],
      isMultiLine: true,
    },
    ...customFieldDetails,
  ];

  function handleStatusButtonClick() {
    if (data.status.toLowerCase() !== CONSTANTS.STATUS.ACTIVE) {
      openUserBlockedAlertBox();
    }
  }

  const showStatusReopenHint = userBlocked.status && !blockAlertVisible;

  const formatStatusStartDateTime = (dateString: string) => {
    // dateString is expected to be in ISO format (e.g., "2023-08-15T14:30:00Z")
    // Return Date in format DD.MM.YYYY HH:mm

    // Handle cases where dateString might be undefined or null
    if (!dateString) {
      return "";
    }
    // Handle edge cases where dateString might not be a valid date
    const parsedDate = Date.parse(dateString); // dateString might be in ISO format or other formats, so we use Date.parse to check if it's valid
    if (isNaN(parsedDate)) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear()).padStart(2, "0");
    
    const formattedStartDate = `${day}.${month}.${year}`
    
    // FormattedStartTime
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const formattedStartTime = `${hours}:${minutes}`;
    return `${formattedStartDate} ${formattedStartTime}`;
  }

  return (
    <div style={{ maxHeight: `${tableHeight}px`, overflow: "auto" }}>
      <PassportPageHeader onSignOut={onSignOut} />
      {loading && <Loading />}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        height="100%"
      >
        {error && (
          <div
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              position: "sticky",
              left: "0",
              zIndex: 200,
            }}
          >
            <AlertBox
              type={"error"}
              message={error}
              onCloseCb={onCloseAlertBox}
            />
          </div>
        )}
        {blockAlertVisible && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                maxWidth: "480px",
                width: "90%",
                textAlign: "center",
                boxShadow: "0px 8px 24px rgba(0,0,0,0.2)",
              }}
            >
              <AlertBox
                type={"error"}
                message={userBlocked.message}
                onCloseCb={onCloseUserBlockedAlertBox}
              />
            </Box>
          </Box>
        )}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          justifyContent="center"
          marginTop={4}
          marginLeft={2}
          border="1px solid #ccc"
          borderRadius="8px"
          padding="16px"
          marginBottom="16px"
          marginRight={2}
          width="43vh"
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <ImageUpload
              photo={photo as string} // Pass existing photo prop if available
              onImageChange={handleImageChange} // Pass handler to update form state
              setAlertBoxState={handleImageUploadError}
              previewOnly={true} // Set to true if you want to disable the upload button and only show the preview
            />
            <Button
              id="status-button"
              variant="contained"
              onClick={handleStatusButtonClick}
              startIcon={
                <img
                  src={CONSTANTS.STATUS_ICONS[data.status.toUpperCase()]}
                  alt="status_active"
                  style={{ width: "20px", height: "20px" }}
                />
              }
              sx={{
                background: `${CONSTANTS.STATUS_BG_COLORS[data.status.toUpperCase()]} 0% 0% no-repeat padding-box`,
                borderRadius: "0px 0px 8px 8px",
                opacity: 1,
                marginTop: "-16px",
                width: 200,
                font: "normal normal 600 12px/27px Inter;",
                textTransform: "capitalize",
                color: CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                boxShadow: "none",
                "&:hover": {
                  background: `${CONSTANTS.STATUS_BG_COLORS[data.status.toUpperCase()]} 0% 0% no-repeat padding-box`,
                  color:
                    CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                  boxShadow: "none",
                },
                "&:active": {
                  background: `${CONSTANTS.STATUS_BG_COLORS[data.status.toUpperCase()]} 0% 0% no-repeat padding-box`,
                  color:
                    CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                  boxShadow: "none",
                },
                "&:focus": {
                  background: `${CONSTANTS.STATUS_BG_COLORS[data.status.toUpperCase()]} 0% 0% no-repeat padding-box`,
                  color:
                    CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                  boxShadow: "none",
                },
                "&:focus-visible": {
                  background: `${CONSTANTS.STATUS_BG_COLORS[data.status.toUpperCase()]} 0% 0% no-repeat padding-box`,
                  color:
                    CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                  boxShadow: "none",
                },
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap="1px"
              >
                <TextLabel type="smallLinkText" sxStyles={{
                  color: CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                }}>{data.status}</TextLabel>
                {data.statusStartDate && (
                  <TextLabel type="smallText" sxStyles={{
                    fontSize: 10,
                    color: CONSTANTS.STATUS_TEXT_COLORS[data.status.toUpperCase()],
                  }}>{`${t("passportPage.labels.since")} ${formatStatusStartDateTime(data.statusStartDate)}`}</TextLabel>
                )}
              </Box>
            </Button>
            {showStatusReopenHint && (
              <TextLabel
                type="smallText"
                sxStyles={{
                  marginTop: "4px",
                  textAlign: "center",
                  maxWidth: "250px",
                  color: CONSTANTS.COLORS.TEXT_BLACK,
                }}
              >
                {t("alertMessages.clickStatusToViewReason") as string}
              </TextLabel>
            )}
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            marginLeft={2}
          >
            <img
              src="/icon_edit.svg"
              alt="icon_edit_pen"
              style={{
                width: "28px",
                height: "28px",
              }}
              onClick={() => handleNavigation("/settings")}
            />
          </Box>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          border="1px solid #ccc"
          borderRadius="8px"
          padding="16px"
          marginBottom="16px"
          width="43vh"
          marginLeft="7vh"
          marginRight="7vh"
        >
          <Stack spacing={0.5} width="100%">
            {profileDetails.map(({ label, value, isMultiLine }, index) => (
              <Stack
                key={`row-${index}`}
                direction="row"
                spacing={2}
                width="100%"
                alignItems="flex-start"
              >
                <TextLabel
                  type="smallLinkText"
                  sxStyles={{
                    textAlign: "left",
                    fontWeight: "bold",
                    minWidth: "120px",
                    flexShrink: 0,
                  }}
                >
                  {label}
                </TextLabel>
                <Box sx={{ flexGrow: 1 }}>
                  {isMultiLine && Array.isArray(value) ? (
                    <Stack spacing={0.2}>
                      {value.map((item, itemIndex) => (
                        <TextLabel
                          key={`value-${index}-${itemIndex}`}
                          type="smallLinkText"
                          sxStyles={{
                            textAlign: "left",
                            wordBreak: "keep-all",
                            overflowWrap: "break-word",
                            hyphens: "none",
                          }}
                        >
                          {item}
                        </TextLabel>
                      ))}
                    </Stack>
                  ) : (
                    <TextLabel
                      type="smallLinkText"
                      sxStyles={{
                        textAlign: "left",
                        wordBreak: "break-word",
                      }}
                    >
                      {value}
                    </TextLabel>
                  )}
                </Box>
              </Stack>
            ))}
          </Stack>
        </Box>

        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          border="1px solid #ccc"
          borderRadius="8px"
          padding="16px"
          width="43vh"
          marginLeft="2vh" // Updated marginLeft to 5vh
          marginRight="2vh"
          marginBottom="1vh"
        >
          <div onClick={handleNavigation} style={{ cursor: "pointer" }}>
            <img
              id="qr-code-image"
              src={qrCode}
              alt={t("passportPage.labels.sections.qrcode")}
              height="180"
              width="175"
            />
          </div>
        </Box>
        <PassportPageBottom />
      </Box>
    </div>
  );
};

export default ProfilePage;
